export default "__VITE_ASSET__4584ce4e__"